// Sinónimos de búsqueda del CIE-10 (Fase 9, piloto parte 2). El catálogo conserva los nombres oficiales de la OPS; lo que
// se escribe en el selector puede usar el vocabulario clínico corriente ("diabetes mellitus tipo 2"), que la CIE-10 no
// usa ("no insulinodependiente"). Solo reescribe lo que se BUSCA: los códigos y sus nombres no cambian.
export const VALUESET_CIE10_MINIMO = 'http://logiacare.ec/fhir/ValueSet/cie10-minimo';

const REGLAS: readonly { readonly patron: RegExp; readonly oficial: string }[] = [
  { patron: /\btipo\s*(?:2|ii)\b/i, oficial: 'no insulinodependiente' },
  { patron: /\btipo\s*(?:1|i)\b/i, oficial: 'insulinodependiente' },
  { patron: /\benfermedad renal\b/i, oficial: 'insuficiencia renal' },
];

/** Búsquedas alternativas con el texto oficial de la CIE-10 (vacío si no hay sinónimo aplicable). */
export function sinonimosBusquedaCie10(filtro: string): string[] {
  const alternativas = new Set<string>();
  for (const { patron, oficial } of REGLAS) {
    if (patron.test(filtro)) alternativas.add(filtro.replace(patron, oficial).replace(/\s+/g, ' ').trim());
  }
  alternativas.delete(filtro.trim());
  return [...alternativas];
}
